import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProfileStats = ({ profile, followingCount, statsPosition, postsCount }) => {
  const navigate = useNavigate();
  const safePostsCount =
    typeof postsCount === 'number'
      ? postsCount
      : (typeof profile?.post_count === 'number' ? profile.post_count : 0);

  return (
    <div className={`profile-stats profile-stats-${statsPosition}`}>
      <div className="stat-item clickable" onClick={() => navigate('/profile/posts')}>
        <p className="stat-value">{safePostsCount}</p>
        <p className="stat-label">Post{safePostsCount !== 1 ? 's' : ''}</p>
      </div>
      <div className="stat-item clickable" onClick={() => navigate('/profile/destinations')}>
        <p className="stat-value">{profile.destination_count || 0}</p>
        <p className="stat-label">destinations</p>
      </div>
      <div className="stat-item clickable" onClick={() => navigate(`/profile/${profile.username}/followers`)}>
        <p className="stat-value">{profile.follower_count || 0}</p>
        <p className="stat-label">Follower{profile.follower_count !== 1 ? 's' : ''}</p>
      </div>
      <div className="stat-item clickable" onClick={() => navigate(`/profile/${profile.username}/following`)}>
        <p className="stat-value">{followingCount}</p>
        <p className="stat-label">Following</p>
      </div>
    </div>
  );
};

export default ProfileStats; 
